import React, { useState } from "react";
import ReactQuill from "react-quill";
import { Formik, Form, ErrorMessage } from "formik";
import { useAuth } from "../../utility/auth";
import * as Yup from "yup";
import {
  Grid,
  Radio,
  FormControlLabel,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import moment from "moment";
import dayjs from "dayjs";
import Controls from "../../components/FormsUI";
import CustomizedSnackbars from "../../components/Alert";
import ContentController from "../../controller/ContentController";
import ContentManageController from "../../controller/ContentManageController";
import ImagePopup from "./ImagePopup";
import ExceptionHandlerController from "../../controller/ErrorLogsController";
import "../../css/style.css";
import "react-quill/dist/quill.snow.css";
const numberRegEx = /^[0-9\b]+$/;

const INITIAL_FORM_STATE = {
  sectionId: "",
  selectedSectionDD: null,
  subSectionId: "",
  description: "",
  selectedSubSection: null,
  place: "",
  title: "",
  contentBody: "",
  amount: "",
  noOfLionPresent: "",
  keyword: "",
  memberContactNo: "",
  dataSource: "",
  memberName: "",
  memberId: "",
  activityType: "",
  memberIdSelected: null,
  memberEmail: "",
};
const FORM_VALIDATION = Yup.object().shape({
  sectionId: Yup.string().required("Section is required"),
  subSectionId: Yup.string().required("Sub section is required"),
  title: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Title field is required"),
  activityType: Yup.string().when("dataSource", {
    is: (dataSource) => dataSource === "Activity",
    then: Yup.string().required("Activity type is required"),
    otherwise: Yup.string().optional(),
  }),
  contentBody: Yup.string().when("subSectionId", {
    is: (subSectionId) =>
      subSectionId !== process.env.REACT_APP_ABOUTUS_SUBSECTIONID,
    then: Yup.string()
      .trim("No white space allowed")
      .required("Body field is required"),
    otherwise: Yup.string().strict(true).optional(),
  }),
  description: Yup.string().when("subSectionId", {
    is: (subSectionId) =>
      subSectionId !== process.env.REACT_APP_ABOUTUS_SUBSECTIONID,
    then: Yup.string()
      .trim("No white space allowed")
      .strict(true)
      .required("Description is required"),
    otherwise: Yup.string()
      .trim("No white space allowed")
      .strict(true)
      .optional(),
  }),
  dataSource: Yup.string().optional(),
  place: Yup.string().trim("No white space allowed").strict(true).optional(),
  amount: Yup.string().trim("No white space allowed").strict(true).optional(),
  noOfLionPresent: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  keyword: Yup.string().trim("No white space allowed").strict(true).optional(),
  memberContactNo: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  memberEmail: Yup.string()
    .email("Incorrect email")
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  beneficiary: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  memberName: Yup.string().when("subSectionId", {
    is: (subSectionId) =>
      subSectionId !== process.env.REACT_APP_ABOUTUS_SUBSECTIONID,
    then: Yup.string().trim("No white space allowed").strict(true).optional(),
    otherwise: Yup.string()
      .trim("No white space allowed")
      .strict(true)
      .required("Member name is required"),
  }),
  memberId: Yup.string()
    .strict(true)
    .when("subSectionId", {
      is: (subSectionId) =>
        subSectionId !== process.env.REACT_APP_ABOUTUS_SUBSECTIONID,
      then: Yup.string().optional().trim("No white space allowed").strict(true),
      otherwise: Yup.string()
        .required("Member designation is required")
        .trim("No white space allowed")
        .strict(true),
    }),
});

let positionNameArray = [];
const ArticlePopup = (props) => {
  var updatedData = props?.updatedData;
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [fetchedSectionNameDD, setFetchedSectionNameDD] = useState([]);
  const contentManageController = new ContentManageController();
  const [positionValue, setPositionValue] = useState(null);
  const [showImagePopUp, setShowImagePopUp] = useState(false);
  const [fetchedSubSectionNameDD, setFetchedSubSectionNameDD] = useState([]);
  const contentController = new ContentController();
  const exceptionHandlerController = new ExceptionHandlerController();
  // const { userid: tenantId } = data.UserInfo;
      const { userid: userId, tenantid: tenantId } = data.UserInfo;

  React.useEffect(() => {
    getMasters();
    if (updatedData?.memberId) getMembersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      [{ color: [] }, { background: [] }],
    ],
  };
  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const getMasters = () => {
    try {
      contentController
        .GetSectionMaster()
        .then((response) => {
          if (response.data.status === 200) {
            const sectionMasterData = response?.data?.body;
            const fetchedSectionName = sectionMasterData.map((item) => ({
              label: item?.sectionName,
              value: item?._id,
            }));
            setFetchedSectionNameDD(fetchedSectionName);
          } else {
            showAlert("error", response?.data?.body?.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching section data API LEVEL:", error);
        });
    } catch (error) {
      console.error("error in getMasters home page", error);
    }
  };
  const getMembersData = () => {
    let caughtError;
    try {
      contentManageController.getMemberMasters().then((response) => {
        if (response?.status === 200) {
          const memberMastersData = response?.data?.body;
          if (positionNameArray.length === 0) {
            memberMastersData?.map((item) => {
              return positionNameArray.push({
                label: item?.positionName,
                value: item?._id,
              });
            });
          }
          if (updatedData?.memberId) {
            const filteredData = memberMastersData.filter(
              (item) => item?._id === updatedData?.memberId
            )[0];
            const { positionName, _id } = filteredData;
            const filteredObject = { label: positionName, value: _id };
            setPositionValue(filteredObject);
          }
        } else {
          showAlert("error", response?.response?.data?.message);
        }
      });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "multimedia page getMembersData method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const submitValues = (valuesData) => {
    valuesData.tenantId = tenantId;

    if (props?.updatedData?.contentId) {
      handleUpdate(valuesData).catch(handleError);
    } else {
      handleCreate(valuesData).catch(handleError);
    }
  };

  const handleUpdate = async (updateValues) => {
    const newData = prepareDataForUpdate(updateValues);

    const response = await contentController.UpdateData(newData, token);
    if (response?.data?.status === 200) {
      handleSuccess(response);
    } else {
      showAlert("error", response?.response?.data?.message);
    }
  };

  const handleCreate = async (createValues) => {
    const newData = prepareDataForCreate(createValues);

    const response = await contentController.CreateData(newData, token);
    if (response?.data?.status === 201) {
      handleCreateSuccess(response);
      props.setActiveButton("images");
    } else {
      showAlert("error", response?.response?.data?.message);
    }
  };

  const prepareDataForUpdate = (updatedata) => {
    const newData = { ...updatedata, contentId: props?.updatedData?.contentId };
    newData.sectionName = updatedata?.selectedSectionDD?.label;
    newData.subSectionName = updatedata?.selectedSubSection?.label;

    // Remove unnecessary properties
    [
      "_id",
      "createdDate",
      "image",
      "selectedSectionDD",
      "selectedSubSection",
      "coverImageIndex",
    ].forEach((key) => delete newData[key]);

    return newData;
  };

  const prepareDataForCreate = (dataCreate) => {
    dataCreate.sectionName = dataCreate?.selectedSectionDD?.label;
    dataCreate.subSectionName = dataCreate?.selectedSubSection?.label;

    // Remove unnecessary properties
    ["selectedSectionDD", "selectedSubSection", "contentId", "image"].forEach(
      (key) => delete dataCreate[key]
    );

    return dataCreate;
  };

  const handleCreateSuccess = (response) => {
    const body = response?.data?.body;

    updateUpdatedData(body);
    updateNumberMinMax(body);

    props.getSectionsGrid();
    setShowImagePopUp(true);
    resetAlert();
  };

  const updateUpdatedData = (body) => {
    const updatedValue = buildUpdatedData(body);
    props.setUpdatedData((prev) => ({ ...prev, ...updatedValue }));
  };

  const buildUpdatedData = (body) => {
    const defaults = {
      tenantId: "",
      sectionId: "",
      subSectionId: "",
      description: "",
      sectionName: "",
      subSectionName: "",
      title: "",
      dateOfEvent: "",
      place: "",
      dataSource: "",
      positionName: "",
      memberId: "",
      memberName: "",
      memberEmail: "",
      contentBody: "",
      keyword: "",
      image: [],
    };

    return {
      contentId: body?._id,
      ...defaults,
      ...body,
    };
  };

  const updateNumberMinMax = (body) => {
    props.setNumberMinMax((prev) => ({
      ...prev,
      noOfLionPresent: body?.noOfLionPresent ?? "",
      amount: body?.amount ?? "",
      memberContactNo: body?.memberContactNo ?? "",
      beneficiary: body?.beneficiary ?? "",
    }));
  };

  const handleSuccess = (response) => {
    showAlert("success", response?.data?.message);
    props.getSectionsGrid();
    resetAlert();
  };

  const resetAlert = () => {
    setTimeout(() => {
      setAlert({ counter: 0, type: "", msg: "" });
    }, 10000);
  };

  const handleError = (error) => {
    console.error("error in submitValues home", error);
    const logData = { message: error?.message, stack: error?.stack };
    const logError = { logData, module: "Content manage submitValues method" };
    exceptionHandlerController.HandleException(logError);
  };

  const resetFields = (setFieldValue, setNumberMinMax) => {
    setFieldValue("memberName", "");
    setFieldValue("memberId", "");
    setFieldValue("title", "");
    setFieldValue("dateOfEvent", null);
    setFieldValue("place", "");
    setFieldValue("description", "");
    setFieldValue("contentBody", "");
    setFieldValue("dataSource", "");
    setFieldValue("keyword", "");
    setFieldValue("memberEmail", "");
    setNumberMinMax({
      noOfLionPresent: "",
      amount: "",
      memberContactNo: "",
      beneficiary: "",
    });
  };
  const getMasterSS = (id) => {
    try {
      contentController.getMasterSubSection(id).then((response) => {
        setFetchedSubSectionNameDD([]);
        if (response.data.status === 200) {
          const masterSubSectionData = response?.data?.body;
          const updateSubSectionDD = masterSubSectionData.map((item) => ({
            label: item?.subSectionName,
            value: item?._id,
          }));
          setFetchedSubSectionNameDD(updateSubSectionDD);
        } else {
          showAlert("error", response?.data?.body?.message);
        }
      });
    } catch (error) {
      console.error("error: ", error);
    }
  };
  if (showImagePopUp) return <ImagePopup props={props} />;
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          ...(updatedData.sectionId ? updatedData : INITIAL_FORM_STATE),
        }}
        validationSchema={FORM_VALIDATION}
        onSubmit={(values) => submitValues(values)}
      >
        {({ values, setFieldValue, setFieldTouched }) => (
          <Form>
            <Grid container spacing={2}>
              {updatedData?.sectionId ? (
                <Grid item xs={12} md={12}>
                  <b>
                    {`${updatedData?.sectionName} > ${updatedData?.subSectionName}`}
                  </b>
                </Grid>
              ) : (
                <>
                  <Grid item xs={12} md={6}>
                    <Controls.AutoComplete
                      id="sectionId"
                      name="sectionId"
                      options={fetchedSectionNameDD}
                      value={values?.selectedSectionDD}
                      label={
                        <span>
                          Section <span className="asterisk">*</span>
                        </span>
                      }
                      onChange={(event, value) => {
                        //clear all fields on change on this
                        setFieldValue("subSectionId", "");
                        setFieldValue("selectedSubSection", null);
                        setFieldValue("sectionId", value?.value);
                        setFieldValue("selectedSectionDD", value);
                        getMasterSS(value?.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controls.AutoComplete
                      id="subSectionId"
                      name="subSectionId"
                      options={fetchedSubSectionNameDD}
                      value={values?.selectedSubSection}
                      label={
                        <span>
                          Sub Section <span className="asterisk">*</span>
                        </span>
                      }
                      onChange={(event, value) => {
                        if (value) {
                          resetFields(setFieldValue, props.setNumberMinMax);
                          setFieldValue("subSectionId", value?.value);
                          setFieldValue("selectedSubSection", value);
                          if (
                            value.value ===
                            process.env.REACT_APP_ABOUTUS_SUBSECTIONID
                          ) {
                            getMembersData();
                          }
                        }
                      }}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12} md={6}>
                <Controls.Textfield
                  id="title"
                  name="title"
                  value={values?.title}
                  inputProps={{ maxLength: 50 }}
                  label={
                    <span>
                      Title <span className="asterisk">*</span>
                    </span>
                  }
                />
              </Grid>
              {values.subSectionId !==
                process.env.REACT_APP_ABOUTUS_SUBSECTIONID ? (
                <>
                  <Grid item xs={12} md={6}>
                    <Controls.Textfield
                      id="keyword"
                      name="keyword"
                      value={values?.keyword}
                      inputProps={{ maxLength: 200 }}
                      label="Keywords"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Controls.DateTimePicker
                      id="dateOfEvent"
                      name="dateOfEvent"
                      label="Date of event"
                      value={
                        values?.dateOfEvent
                          ? dayjs(values.dateOfEvent, "DD/MM/YYYY")
                          : null
                      }
                      onChange={(e) => {
                        setFieldTouched("dateOfEvent", true);
                        const formattedDate = moment(new Date(e)).format(
                          "DD/MM/YYYY"
                        );
                        setFieldValue("dateOfEvent", formattedDate);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controls.Textfield
                      id="place"
                      name="place"
                      value={values?.place}
                      label="Place"
                      inputProps={{ maxLength: 30 }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controls.Textfield
                      id="noOfLionPresent"
                      name="noOfLionPresent"
                      inputProps={{ maxLength: 3 }}
                      value={props.numberMinMax.noOfLionPresent}
                      label="No of Lion Present"
                      onChange={(event) => {
                        const { value } = event?.target;
                        if (numberRegEx.test(value) || value === "") {
                          props.setNumberMinMax((prev) => ({
                            ...prev,
                            noOfLionPresent: value,
                          }));
                          setFieldValue("noOfLionPresent", value);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controls.Textfield
                      id="amount"
                      name="amount"
                      value={props.numberMinMax?.amount}
                      label="Amount"
                      inputProps={{ maxLength: 10 }}
                      onChange={(event) => {
                        const { value } = event?.target;
                        if (numberRegEx.test(value) || value === "") {
                          props.setNumberMinMax((prev) => ({
                            ...prev,
                            amount: value,
                          }));
                          setFieldValue("amount", value);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Controls.Textfield
                      id="description"
                      name="description"
                      value={values?.description}
                      label={
                        <span>
                          Description <span className="asterisk">*</span>
                        </span>
                      }
                      inputProps={{ maxLength: 250 }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controls.Textfield
                      id="beneficiary"
                      name="beneficiary"
                      value={props.numberMinMax?.beneficiary}
                      label="Beneficiary"
                      inputProps={{ maxLength: 10 }}
                      onChange={(event) => {
                        const { value } = event?.target;
                        if (numberRegEx.test(value) || value === "") {
                          props.setNumberMinMax((prev) => ({
                            ...prev,
                            beneficiary: value,
                          }));
                          setFieldValue("beneficiary", value);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Grid className="tabdata">
                      <h4 className="tabhead">Data Source</h4>
                      <FormControl component="fieldset">
                        <RadioGroup
                          name="dataSource"
                          value={values.dataSource}
                          onChange={(event) => {
                            setFieldValue("dataSource", event.target.value);
                            setFieldValue("activityType", "");
                          }}
                        >
                          <FormControlLabel
                            value="Activity"
                            control={<Radio />}
                            label="Activity"
                          />
                          <FormControlLabel
                            value="Fellowship"
                            control={<Radio />}
                            label="Fellowship"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {values?.dataSource === "Activity" && (
                    <Grid item xs={12} md={6}>
                      <Grid className="tabdata">
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            Select Project Type
                          </FormLabel>
                          <RadioGroup
                            name="activityType"
                            value={values.activityType}
                            onChange={(event) => {
                              setFieldValue("activityType", event.target.value);
                            }}
                          >
                            <FormControlLabel
                              value="One Time Project"
                              control={<Radio />}
                              label="One Time Project"
                            />
                            <FormControlLabel
                              value="Permanent Project"
                              control={<Radio />}
                              label="Permanent Project"
                            />
                            <FormControlLabel
                              value="null"
                              control={<Radio />}
                              label="Not Required"
                            />
                            <ErrorMessage name="activityType">
                              {(msg) => (
                                <div
                                  style={{
                                    color: "#d32f2f",
                                    marginTop: "45px",
                                  }}
                                >
                                  {msg}
                                </div>
                              )}
                            </ErrorMessage>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <h3 className="upload">
                      Content Body <span className="asterisk">*</span>
                    </h3>
                    <Grid item xs={12} md={12} className="marginAuto">
                      <ReactQuill
                        value={values.contentBody}
                        name="contentBody"
                        style={{ height: "150px", marginBottom: "45px" }}
                        modules={modules}
                        onChange={(value) =>
                          setFieldValue("contentBody", value)
                        }
                      />
                    </Grid>

                    <Grid className="col-lg-12 col-md-12 l-float">
                      <ErrorMessage name="contentBody">
                        {(msg) => <div style={{ color: "#d32f2f" }}>{msg}</div>}
                      </ErrorMessage>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={12} md={6}>
                    <Controls.Textfield
                      id="memberName"
                      name="memberName"
                      inputProps={{ maxLength: 30 }}
                      label={
                        <span>
                          Member Name <span className="asterisk">*</span>
                        </span>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controls.Textfield
                      id="memberEmail"
                      name="memberEmail"
                      inputProps={{ maxLength: 30 }}
                      label="Member E-mail Id"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Controls.Textfield
                      id="memberContactNo"
                      name="memberContactNo"
                      value={props.numberMinMax?.memberContactNo}
                      label="Member Contact No"
                      inputProps={{ maxLength: 10 }}
                      onChange={(event) => {
                        const { value } = event?.target;
                        if (numberRegEx.test(value) || value === "") {
                          props.setNumberMinMax((prev) => ({
                            ...prev,
                            memberContactNo: value,
                          }));
                          setFieldValue("memberContactNo", value);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controls.AutoComplete
                      id="memberId"
                      name="memberId"
                      options={positionNameArray}
                      value={positionValue}
                      label={<span>
                        Select Member Designation <span className="asterisk">*</span>
                      </span>}
                      onChange={(event, value) => {
                        setFieldValue("memberId", value?.value);
                        setPositionValue(value);
                      }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            <Grid item xs={4} md={2} className="marginAuto">
              <Controls.Button> Submit </Controls.Button>
            </Grid>
            {alert.counter > 0 && (
              <CustomizedSnackbars
                status={alert.counter}
                msg={alert.msg}
                type={alert.type}
              />
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};
export default ArticlePopup;
